export const BUILD_INFO = {
	branch: 'dev',
	repoUrl: 'https://github.com/Demeter-Tactical-Investments/UI'
};
